exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty-message{margin:15px 0;text-align:center}.nav-tabs{border-bottom:1px solid #cccccc70;margin-bottom:15px}.nav>li>a{padding:5px 10px;color:#000}.nav-tabs>li>a{border-radius:0;border:none;border-bottom:2px solid transparent}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#10b2ff;border:none;border-bottom:2px solid #10b2ff}.nav-tabs>li>a:hover{border-bottom-color:#ccc}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:inherit;outline:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./yii2/frontend/frontend-assets/src/components/AdminPanel/Users/UserDetails.css
// module id = 2790
// module chunks = 0